import { DateRange } from 'app/shared/models/date-range.model';

export class CaseActivityListFilterModel {
  constructor(
    public summary: string = '',
    public activityDate: DateRange = { start: null, end: null },
    public activityType: number = 0
  ) {}
}
